import { render, staticRenderFns } from "./Town.vue?vue&type=template&id=846c44cc&scoped=true&"
import script from "./Town.vue?vue&type=script&lang=js&"
export * from "./Town.vue?vue&type=script&lang=js&"
import style0 from "./Town.vue?vue&type=style&index=0&id=846c44cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846c44cc",
  null
  
)

export default component.exports